import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBYlH54QpMBRAOzlK_DWtKv1D6R0Vs596A',
  authDomain: 'medicia-patient-app.firebaseapp.com',
  projectId: 'medicia-patient-app',
  storageBucket: 'medicia-patient-app.firebasestorage.app',
  messagingSenderId: '469059271165',
  appId: '1:469059271165:web:a256c3c8e11bbdf4244194',
  measurementId: 'G-N76ZYZS6Z9',
};

export const app = initializeApp(firebaseConfig);
export const messagingSupportedPromise = isSupported();
export const getMessagingSafe = async () =>
  (await messagingSupportedPromise) ? getMessaging(app) : null;

// Get (or create) the WebPush token using your VAPID public key
export const getFcmToken = async (vapidKey) => {
  console.log('[FCM] getFcmToken called with VAPID key:', vapidKey);
  const messaging = await getMessagingSafe();
  if (!messaging) return null;

  const swReg = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });
  await navigator.serviceWorker.ready;

  return await getToken(messaging, { vapidKey, serviceWorkerRegistration: swReg });
};

// Foreground push messages (when tab is visible)
export const onForegroundMessage = async (cb) => {
  const messaging = await getMessagingSafe();
  console.log('[FCM] onForegroundMessage', messaging);
  if (!messaging) return () => {};
  return onMessage(messaging, cb);
};
